export function enabledTableHeaders(headers, response) {
  let result = [];
  let headersResponse = Object.keys(response[0]);

  if (response.length > 0) {
    headers.forEach(header => {
      if (headersResponse.indexOf(header.key) !== -1) {
        result.push(header.label);
      }
    });
  }

  return result;
}

export function isPermissionEnabled(permissionsItems, value = "") {
  if (value.indexOf("/") !== -1) {
    let permissionStr = value.split("/");
    let permissionFather = permissionStr[0];
    let permissionAction = permissionStr[1];

    if (permissionsItems.hasOwnProperty(permissionFather)) {
      return permissionsItems[permissionFather].indexOf(permissionAction) !== -1;
    } else {
      return false;
    }
  } else {
    return permissionsItems.hasOwnProperty(value);
  }
}

export function enabledPermissions(configItems, permissionsItems, hasGlobalAdmin = false, isSuperUser = false) {
  const enabledItems = [];
  configItems.forEach(item => {
    const flagSubmenu = item.submenu && item.submenu.length > 0
    let submenu = [];
    if (flagSubmenu) {
      submenu = enabledPermissions(item.submenu, permissionsItems, hasGlobalAdmin, isSuperUser);
    }
    if (window.localStorage.getItem('isAdmin') == 'true') {
      const hasVisibleAdminFlag = item.visibilityAdmin === true || submenu.length > 0;
      const hasVisibleGlobalAdminFlag = hasGlobalAdmin && item.visibilityAdminGlobal === true;

      if (hasVisibleAdminFlag || hasVisibleGlobalAdminFlag) {
        const itemCopy = {
          ...item,
          submenu
        };
        enabledItems.push(itemCopy);
      }
    } else if (isSuperUser) {
      const shouldInclude =
        !item.visibilityAdminGlobal

      if (shouldInclude) {
        const itemCopy = {
          ...item,
          submenu
        };
        enabledItems.push(itemCopy);
      }
    } else {
      const checkSubmenu = (flagSubmenu && (submenu.length > 0 || item.routing)) || !flagSubmenu;
      const checkPermission = !item.permissionName || (item.permissionName && isPermissionEnabled(permissionsItems, item.permissionName));

      if (checkSubmenu && checkPermission) {
        const itemCopy = {
          ...item,
          submenu: submenu
        }
        enabledItems.push(itemCopy);
      }
    }
  });

  return enabledItems;
}
